<section class="touch-slider-wrp mt-5" *ngIf="responseReceived && brands.length > 0">
  <div class="container">
    <div class="touch-slider-wrp-inner">
      <h4 class="heading-w-border mb-2">
        <span>Most Loved Brands</span>
      </h4>

      <div class="touch-slider">

        <div uk-slider>
          <div class="uk-position-relative">

            <div class="uk-slider-container uk-light mt-5">
              <ul
                class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-6@m uk-grid-small uk-flex-middle"
                uk-grid>

                <li *ngFor="let brand of brands">
                  <div class="brand-logo">
                    <a
                      [routerLink]="['/'+appService.getCurrentCity().toLowerCase()+'/deals/by/'+brand.merchant_slug]">
                      <img src="{{brand.logo}}" alt="">
                    </a>
                  </div>
                </li>

              </ul>
            </div>
            <!--uk-slider-container--->

            <a class="uk-position-center-left-out custom-nav hideMobile" href="#" uk-slidenav-previous
               uk-slider-item="previous">
              <img src="assets/images/icons/arrow-right.png" alt="">
            </a>
            <a class="uk-position-center-right-out custom-nav hideMobile" href="#" uk-slidenav-next
               uk-slider-item="next">
              <img src="assets/images/icons/arrow-right.png" alt="">
            </a>

          </div>
        </div>

      </div>
      <!--touch-slider-wrp-inner--->
    </div>
  </div>
  <!--container--->
</section>

<!--Skeleton Loader-->
<section class="touch-slider-wrp mt-5" hidden>
  <div class="container">
    <div class="touch-slider-wrp-inner">

      <div class="touch-slider">

        <div uk-slider>
          <div class="uk-position-relative">

            <div class="uk-slider-container uk-light mt-5">
              <ul
                class="uk-slider-items uk-child-width-1-2 uk-child-width-1-3@s uk-child-width-1-6@m uk-grid-small uk-flex-middle"
                uk-grid *ngIf="!responseReceived">

                <li *ngFor="let brand of brands">
                  <ngx-skeleton-loader animation="progress" appearance="line"></ngx-skeleton-loader>
                </li>

              </ul>
            </div>
            <!--uk-slider-container--->


          </div>
        </div>

      </div>
      <!--touch-slider-wrp-inner--->
    </div>
  </div>
  <!--container--->
</section>
